<template>
  <br />
  <div
    class="content"
    :style="{ backgroundImage: 'url(/home-main-image.png)' }"
  >
    <div class="intro">
      <div class="divy">
        <h2>Call Recording and Telephone Management Systems? Yes! Welcome!</h2>
        <p>
          You have reached the home of Datatex Dynamics, specializing in
          telephony solutions, focusing on
          <strong> Call recording, Telephone management</strong>, and
          <strong>Quality assurance</strong> software.
          <strong> Founded in 1994</strong>, the company has developed a range
          of products to support businesses in managing and optimizing their
          telecommunication systems.
        </p>
        <br />
        <h4>
          South Africa’s Leading Telephone Call Recording System and Quality
          Management Software Supplier.
        </h4>
      </div>
    </div>
  </div>
  <br />
  <br />
  <br />
  <section class="content-section visible last-section">
    <h5>We support all of the top PABX vendors on the market to date.</h5>
    <div class="marquee-rtl">
      <div class="marquee-content">
        <img src="/3CX Image.png" alt="" loading="lazy" />
        <img src="/AVAYA Image.png" alt="" loading="lazy" />
        <img src="/Bicom Image.png" alt="" loading="lazy" />
        <img src="/CISCO Image.png" alt="" loading="lazy" />
        <img src="/Microsoft Teams Image.png" alt="" loading="lazy" />
        <img src="/Mitel Image.png" alt="" loading="lazy" />
        <img src="/PortaOne Image.png" alt="" loading="lazy" />
        <img src="/original-samsung-logo.png" alt="" loading="lazy" />
        <img src="/Yeastar Image.png" alt="" loading="lazy" />

        <!-- Image list continues -->

        <img src="/3CX Image.png" alt="" loading="lazy" />
        <img src="/AVAYA Image.png" alt="" loading="lazy" />
        <img src="/Bicom Image.png" alt="" loading="lazy" />
        <img src="/CISCO Image.png" alt="" loading="lazy" />
        <img src="/Microsoft Teams Image.png" alt="" loading="lazy" />
        <img src="/Mitel Image.png" alt="" loading="lazy" />
        <img src="/PortaOne Image.png" alt="" loading="lazy" />
        <img src="/original-samsung-logo.png" alt="" loading="lazy" />
        <img src="/Yeastar Image.png" alt="" loading="lazy" />

        <!-- Image list continues -->

        <img src="/3CX Image.png" alt="" loading="lazy" />
        <img src="/AVAYA Image.png" alt="" loading="lazy" />
        <img src="/Bicom Image.png" alt="" loading="lazy" />
        <img src="/CISCO Image.png" alt="" loading="lazy" />
        <img src="/Microsoft Teams Image.png" alt="" loading="lazy" />
        <img src="/Mitel Image.png" alt="" loading="lazy" />
        <img src="/PortaOne Image.png" alt="" loading="lazy" />
        <img src="/original-samsung-logo.png" alt="" loading="lazy" />
        <img src="/Yeastar Image.png" alt="" loading="lazy" />

        <!-- Image list continues -->

        <img src="/3CX Image.png" alt="" loading="lazy" />
        <img src="/AVAYA Image.png" alt="" loading="lazy" />
        <img src="/Bicom Image.png" alt="" loading="lazy" />
        <img src="/CISCO Image.png" alt="" loading="lazy" />
        <img src="/Microsoft Teams Image.png" alt="" loading="lazy" />
        <img src="/Mitel Image.png" alt="" loading="lazy" />
        <img src="/PortaOne Image.png" alt="" loading="lazy" />
        <img src="/original-samsung-logo.png" alt="SAM" loading="lazy" />
        <img src="/Yeastar Image.png" alt="" loading="lazy" />
      </div>
    </div>
  </section>
  <br />
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>
* {
  margin: 0;
}

.content {
  position: relative;
  width: 100%;
  height: auto;
  margin: 50px auto 0px auto;
  /* max-width: 1200px; */
  height: auto;
  background-size: cover;
  background-position: center 10%;
  display: grid;
  /* justify-content: center;
  grid-template-columns: 12fr 12fr;
  grid-template-rows: 6fr 0fr;
  justify-items: end; */
  box-shadow: 0 5px 20px #555;
  text-align: justify;
  text-justify: inter-word;
}

.content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(192, 192, 151, 0.6),
    rgba(0, 0, 0, 0.6)
  );
  z-index: 0;
  box-shadow: 0 5px 20px #555;
}

.content > * {
  position: relative;
  z-index: 1; /* Keeps the text above the overlay */
}
h1,
h2 {
  letter-spacing: 0.04em;
  color: #2c4a66;
  font-size: 36px;
  line-height: 1.4em;
}

h4 {
  color: #2c4a66;
  letter-spacing: 0.04em;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.4em;
}

strong {
  color: #000;
  font-size: 23px;
  font-weight: bold;
  line-height: 1.4em;
  letter-spacing: 0.03em;
}

p {
  color: #000;
  font-size: 23px;
  font-weight: 400;
  line-height: 1.4em;
  letter-spacing: 0.03em;
}

.intro {
  padding: 10em 4em 10em 0em;
  width: 50%;
  margin-left: 10%;
}

.image {
  background-position: right;
  border-radius: 20px;
  box-shadow: 0 5px 20px #777;
  width: 420px;
}

/******************************************************/

@media only screen and (max-width: 768px) {
  .content {
    margin: 0;
    grid-template-columns: 1fr;
    grid-template-rows: 5fr 30px 6fr;

    min-height: 80vh;
    max-height: 100vh;
  }
  .content .intro {
    grid-row: 1;
    padding: 4em 0em 0em 0em;
    width: 80%;
    text-align: left;
  }
  .content {
    grid-row: 1;
    background-position: 90% 20%;
    min-height: 200px;
  }
  .content nav {
    grid-row: 2;
  }
  body {
    grid-auto-rows: 1fr;
    align-items: start;
  }
  h2 {
    font-size: 5vw;
  }
  p,
  strong {
    font-size: 1em;
  }
  h4 {
    font-size: 4vw;
  }
  .circle {
    display: none;
  }
  .marquee-rtl {
    padding: 0.5rem 0;
    margin-top: 20px;
  }
  .marquee-content img {
    height: 40px;
    margin-right: 1rem;
  }
}

@media only screen and (max-width: 900px) and (min-width: 769px) {
  .content {
    min-height: 70vh;
  }
  .content .intro {
    padding: 3em 2em 2em 2em;
  }
  h2 {
    font-size: 4vw;
  }
  p {
    font-size: 0.95em;
  }
  h4 {
    font-size: 3vw;
  }
  .marquee-content img {
    height: 45px;
    margin-right: 1.2rem;
  }
}
.content-section h5 {
  background-color: #2c4a66;
  padding: 10px 0px 10px 0px;
  color: white;
  text-align: center;
}

.last-section .image-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.last-section img {
  width: auto;
  transition: transform 0.5s ease;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.marquee-rtl {
  width: 100%;
  overflow: hidden;
  background: white;
  padding: 2.5rem 0rem 1rem 0rem;
  border-bottom: 43px solid white;
  box-shadow: 0 4px 10px #777;
}

.marquee-content {
  display: flex;
  width: max-content;
  animation: scroll-loop 180s linear infinite;
}

.marquee-content img {
  height: 70px;
  margin-right: 1.5rem;
  flex-shrink: 0;
}

@keyframes scroll-loop {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
